import { CalendarDaysIcon, ClockIcon, HeartIcon, MapPinIcon } from '@heroicons/react/24/outline'
import { photos } from '../assets/photos'

const iconStyle = { width: 22, height: 22, flex: '0 0 auto' }

const Hero = () => (
	<section className='hx-hero hx-bleed'>
		{/* Decorative: the scrim and the copy carry the meaning, so the photo stays out of
		    the accessibility tree. */}
		{photos.heroProgram && <img className='hx-hero__photo' src={photos.heroProgram} alt='' />}
		<div className='hx-hero__scrim' />
		<div className='hx-wrap hx-hero__inner'>
			<div>
				<p className='hx-hero__eyebrow'>Välkommen till</p>
				<h1>Harmoni Expo</h1>
				<p className='hx-hero__tagline'>En helg för Kropp &amp; Själ</p>
				<ul className='hx-hero__facts'>
					<li>
						<CalendarDaysIcon style={iconStyle} aria-hidden='true' />
						24–25 oktober 2026
					</li>
					<li>
						<MapPinIcon style={iconStyle} aria-hidden='true' />
						Solnahallen, Stockholm
					</li>
					<li>
						<ClockIcon style={iconStyle} aria-hidden='true' />
						10.00–18.00
					</li>
				</ul>
			</div>
			<div className='hx-seal'>
				<div className='hx-seal__years'>30 år</div>
				<div className='hx-seal__caption'>
					av inspiration,
					<br />
					möten och
					<br />
					utveckling
				</div>
				<HeartIcon style={{ width: 18, height: 18, marginTop: 10 }} aria-hidden='true' />
			</div>
		</div>
	</section>
)

export default Hero
